import React, { ReactNode } from 'react';
import { IUnit } from "../../../util/varibles/interface";

interface IProps {
    unit?: { unit_diseases?: IUnit['unit_diseases'] }
    empty?: string | ReactNode
}

const UnitDisease: React.FC<IProps> = ({ unit, empty = '-' }) => {
    const { unit_diseases } = unit || {};
    const { types = [] } = unit_diseases || {};

    return <>
        {types.length === 0 ? empty : types.map((item: any) => item.name).join(", ")}
    </>;
};

export default UnitDisease;
